import { Component, OnInit, ViewChild, ElementRef, Input, Optional, ContentChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as FileSaver from 'file-saver';
import { ActivatedRoute } from '@angular/router';

import { RemoteDesktopManager } from './ngx-remote-desktop/services/remote-desktop-manager.service';
import { ClipboardModalComponent } from './clipboard/clipboardmodal.component';
import { IdentifierTableColumn, LoginService, RadioComponent, SelectDialogComponent, TableColumn } from '@serengeti/serengeti-common';
import { Configurations } from '../../Configuration';
import { environment } from '../../environments/environment';
import { RemoteDesktopComponent } from './ngx-remote-desktop/components/remote-desktop.component';
import { MatDialog } from '@angular/material';

@Component({
	selector: 'lib-remote-console',
	templateUrl: './console.component.html',
	styleUrls: [
		'./console.component.scss'
	]
})
export class RemoteConsoleComponent implements OnInit {
	public manager: RemoteDesktopManager;
	@Input() instance = {
		"id": null as string, // "6e0c7eca-cf05-492c-a744-b34951b1a2a2",
		"name": "k8s-daejeon-20220428-074813-591",
		"publicIp": "127.0.0.1",

		"protocol": 'kubernetes',
		"hostname": '183.111.68.73',
		"port": 6443,
		"use-ssl": true,
		"ignore-cert": true,
		"ca-cert": 'LS0tLS1CRUdJTiBDRVJUSUZJQ0FURS0tLS0tCk1JSUM1ekNDQWMrZ0F3SUJBZ0lCQURBTkJna3Foa2lHOXcwQkFRc0ZBREFWTVJNd0VRWURWUVFERXdwcmRXSmwKY201bGRHVnpNQjRYRFRJeE1ERXlPVEEwTURRMU5sb1hEVE14TURFeU56QTBNRFExTmxvd0ZURVRNQkVHQTFVRQpBeE1LYTNWaVpYSnVaWFJsY3pDQ0FTSXdEUVlKS29aSWh2Y05BUUVCQlFBRGdnRVBBRENDQVFvQ2dnRUJBTEppCnNtSjFrNllJSFo0bll1ZDF2L3FwNTIzZFlsTksza0FHSk04UEt4Y2o0dGI1MUV1MnZMcUhCdXR6L2xDdEtyUzIKTGNSdHdleU9YM0lySjhLUFNXQ1ZPK2NPZlZCL2hpbkgwbG5Xb2NHcnV6UFF4OTJtMUVWYStpbFRmL1ArcnVpNgpYaWZKb0U5cWo1N1RuZC9EVndraDdMM3MzWld0NFpmL3lKcXV0L2l4VFFid2pzTkdVKzhlMi8ybFo1VitvZURGCkJWQ0JZSXpTaENpYlpGYVFpNzFpc0luYkRxYnh0cXo5bE1HZnBTRmhPOEJLeG0zeDJUb1NiZmFnYk5CcEtIMksKeXpPTXBESkYxQXorQnFOdWlUaXM4YzQveloyQncvQjdDcWFVSk8xUDdldWh6Si9RaW00QkZqeWExeFJCenVGQwp2RExCNUtmcmlhVllqYjBuaVE4Q0F3RUFBYU5DTUVBd0RnWURWUjBQQVFIL0JBUURBZ0trTUE4R0ExVWRFd0VCCi93UUZNQU1CQWY4d0hRWURWUjBPQkJZRUZQVWxGZXNiTXhybjVwc0NONmFWc096TzRTZjdNQTBHQ1NxR1NJYjMKRFFFQkN3VUFBNElCQVFCakpXVU9TV1l3NmVuK3J5d0F6emx4aG55dStCM0dUSGp1NHVVWWJTSzg5Sll2TUZiYgozVXhmOTRzQU80Q3hxR2FFREFMZS9ZK3pQcHVyUjh2MDdaZHUyL3A1QWdvczFCOXBORjJlYzBHeDdqYUNyREIyCnFzWmpXM3pVSVZpdC80SXlURjNtSU8vUnZLTE1RNXlvS0psRVJkK0Jzb3ZuSkpxWi9qY0dXN0RsbExwZWNCT2gKanJja1g1a1c3Y2dINjE0eFVOWi9hcmFIVHN4WE5WaFhmOGROVGttejBqSWh6R1pvZ3lSLzBhdlJ1cElOZ3lBOQpFTjZDeld5c1BpaDY0WDJCVU1NLy9yUEM3YVM2SDBaQUxDM2YrL2lUd2N6VHQ1eGNabTg1SUExRm5MRVd0NkM1CmhuZjZFRmJKaTBwdnhmYkp2UU5kbTExRnV0cW1ycFNyZmtwYwotLS0tLUVORCBDRVJUSUZJQ0FURS0tLS0tCg==',
		"client-cert": 'LS0tLS1CRUdJTiBDRVJUSUZJQ0FURS0tLS0tCk1JSURFekNDQWZ1Z0F3SUJBZ0lJZmZZL05qVm56RTR3RFFZSktvWklodmNOQVFFTEJRQXdGVEVUTUJFR0ExVUUKQXhNS2EzVmlaWEp1WlhSbGN6QWVGdzB5TVRBeE1qa3dOREEwTlRaYUZ3MHlNekF5TURNd01UTTNNakJhTURReApGekFWQmdOVkJBb1REbk41YzNSbGJUcHRZWE4wWlhKek1Sa3dGd1lEVlFRREV4QnJkV0psY201bGRHVnpMV0ZrCmJXbHVNSUlCSWpBTkJna3Foa2lHOXcwQkFRRUZBQU9DQVE4QU1JSUJDZ0tDQVFFQXd4cnh6V0YzaHFETE55VVAKQTNFQU5iN3lmYkZGcnI0eDJRd3ZaY2VtRHVWQWpja0crOFFXaUlNWlRNV0sxMEYrL280dGVIL2tGalVOcTA4UQpsVHdNOXFxZXdoTmp6a0prSWY3anRVVktRSW9OWWZ0UGJjbDJBTWJ2dGNnZk1SV24wUnlDcUxOcGZsbERmUVZ1CnNPRnRoek5EQU5oSENocTQvWVZsUUVyOTBHRVJuOFdkUXBRYzEwZEIyQzhPemNMbWRraDJSMWJBWXNzNmhjbzMKaDd4aGRXaHhyWVFNODlBSmFEaVQ3Y0dDTkNndUwzekhGbjNtOVNFVlNaRVhMTzdtcU4veEV0cGNXcjdNK0JRSQpvaVhiOWlLb0JCb1MwVW9DbWhNb0JpNjkxaFp3MWMyazJ2cWphWUVscDVqSHBYMGxNa2VQNEpFZ05BRnVQL3JXCnY1RjhnUUlEQVFBQm8wZ3dSakFPQmdOVkhROEJBZjhFQkFNQ0JhQXdFd1lEVlIwbEJBd3dDZ1lJS3dZQkJRVUgKQXdJd0h3WURWUjBqQkJnd0ZvQVU5U1VWNnhzekd1Zm1td0kzcHBXdzdNN2hKL3N3RFFZSktvWklodmNOQVFFTApCUUFEZ2dFQkFDVUxxM3dHMW05alltYXNCOGVwdDZQVnI4YllkUVFCSFdnZ0Rzc0RIS0dMeGlCNUJEbk9jYmdjCk9KdjRaMEQ0OTZrd1p3a0d2SWh6TUU2OSsyczVLeUtOV1lTZmVxMlZzeG04N3JaUi9YbzdoWjQzOFBxQ1NmMDUKUCttWUNDRzZjaGpTNlJVU3FMbDJMYWhuUTNHMndMN2xBWWdNTzJmaTExRnFXQVZIT3Z0a3l6WStrVVYxQ2F2OQp5bmwzNXhZRjZTMWdTazhhTmZRSHpmdHN4UXkxTUZZY0lFdFo1d1YrNS85Q1RnR050MXBoOWNXcU8zYk5lNExhCmN6SmhTdG1SZmpWUVczVW5KdXVQclV4WnNOVjBIb1RLWnBVL2FicXV5Rk5NdXU2b2FheUMvUlBwVVRpQnhLbloKNmpxN2U2NXFLSHYvN25lcEtSMEZiRFYxbGN5eFVrdz0KLS0tLS1FTkQgQ0VSVElGSUNBVEUtLS0tLQo=',
		"client-key": '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',
		"exec-command": '/bin/bash',
		"pod": 'k8s-daejeon-20220428-074813-591',
		"container": 'k8s-daejeon-20220428-074813-591',
		"namespace": 'serengeti'
	} as any;
	@Input() setting = {
		showToolbar: true,
		showStatusbar: true,
		disabled: false
	};

	@ViewChild(RemoteDesktopComponent, { static: false })
	public remoteDesktop: RemoteDesktopComponent;

	state = 'CONNECTING';
	isResized = false;
	_vdiContainer: ElementRef;
	@ViewChild('vdiContainer', {static: false}) set vdiContainer(_vdiContainer: ElementRef) {
		this._vdiContainer = _vdiContainer;

		this.handleResize();
	}
	get vdiContainer(): ElementRef {
		return this._vdiContainer;
	}

	config: Configurations;

	constructor(
		route: ActivatedRoute,
		private loginService: LoginService,
		private dialog: MatDialog,
		private ngbModal: NgbModal,
		private snackBar: MatSnackBar,
		@Optional() config: Configurations
	) {
		this.config = config;
	}

	handleResize(retryCount = 0): void {
		if (this.vdiContainer && this.state === 'CONNECTED') {
			const width = this.vdiContainer.nativeElement.clientWidth;
			const height = this.vdiContainer.nativeElement.clientHeight;

			if (width === 0 || height === 0) {
				if (retryCount >= 5) {
					return;
				} else {
					setTimeout(() => this.handleResize(retryCount + 1), 100);
				}
			} else {
				// tslint:disable-next-line: radix
				if ((this.setting.showStatusbar && this.setting.showToolbar) && !this.manager.isFullScreen()) {
					this.manager.sendSize(parseInt(width), parseInt(height) - 60);
				} else if ((this.setting.showStatusbar || this.setting.showToolbar) && !this.manager.isFullScreen()) {
					this.manager.sendSize(parseInt(width), parseInt(height) - 30);
				} else {
					this.manager.sendSize(parseInt(width), parseInt(height));
				}
				this.isResized = true;
			}
		}
	}

	handleScreenshot(): void {
		this.manager.createScreenshot((blob: any) => {
			if (blob) {
				FileSaver.saveAs(blob, `screenshot.png`);
			}
		});
	}

	createModal(classRef: any) {
		this.manager.setFocused(false);
		const modal = this.ngbModal.open(classRef, {
			size: 'lg',
			windowClass: 'modal-xxl',
			container: '.ngx-remote-desktop',
			keyboard: false
		});
		modal.componentInstance.manager = this.manager;
		return modal;
	}

	handleDisconnect(): void {
		this.manager.disconnect();
	}

	handleEnterFullScreen() {
		this.manager.setFullScreen(true);
	}

	handleExitFullScreen() {
		this.manager.setFullScreen(false);
	}

	handleClipboard(): void {
		const modal = this.createModal(ClipboardModalComponent);
		modal.result.then((text) => {
			this.manager.setFocused(true);
			if (text) {
				this.manager.sendRemoteClipboardData(text);
				this.snackBar.open('Sent to remote clipboard', 'OK', {
						duration: 2000,
				});
			}
		}, () => this.manager.setFocused(true));
	}

	handleConnect() {
		let parameters = null;
		const session = this.loginService.loadLoginSession();

		if (session != null) {
			const sessionHeader = {
        LoginId: session.loginId,
        AccessKey: environment.commonOptions.getProduction() ? session.accessKey : environment.commonOptions.testAccessKey,
        SecretKey: environment.commonOptions.getProduction() ? session.secretKey : environment.commonOptions.testSecretKey
			};
			parameters = {
				'font-name': 'courier-new, courier, monospace;',
				'font-size': 12,
				'color-scheme': 'foreground: rgb:ff/ff/ff;',
				'width': window.screen.width,
				'height': window.screen.height
			};
			for (const field in this.instance) {
				parameters[field] = this.instance[field];
			}
			if (this.instance.id) {
				parameters['id'] = this.instance.id;
			}
			if (this.instance.properties && this.instance.properties.ContainerName) {
				const containers = this.instance.properties.ContainerName.split(",").map((container: string) => {
					return {
						'name' : container
					}
				});

				if (containers.length > 1) {
					const containerDialogRef = this.dialog.open(SelectDialogComponent, {
						width: '80vw',
						height: '80vh',
						data: {
							title: 'lib.console.dialog.select-container.title',
							list: containers,
							method: 'data',
							columns: [
								new IdentifierTableColumn('id', 'lib.console.dialog.select-container.content.columns.id', false)
									.withType(RadioComponent),
								new TableColumn('name', 'lib.console.dialog.select-container.content.columns.name')
							]
						}
					});

					containerDialogRef.afterClosed().subscribe(returnValue => {
						  if (returnValue && returnValue.result === true) {
							const container = returnValue.data[0].element.name;

							parameters['container'] = container;
							this.manager.connect(parameters, this.instance, sessionHeader);
						}
					});
				} else {
					parameters['container'] = containers[0].name;
					this.manager.connect(parameters, this.instance, sessionHeader);
				}
			} else {
				this.manager.connect(parameters, this.instance, sessionHeader);
			}
		}
	}

	handleInputListeners(enabled: boolean) {
		if (this.remoteDesktop && this.remoteDesktop.display) {
			if (enabled) {
				this.remoteDesktop.display.bindDisplayInputListeners();
			} else {
				this.remoteDesktop.display.removeDisplayInputListeners();
			}
		}
	}

	ngOnInit() {
		this.manager = new RemoteDesktopManager(this.config);
		this.handleConnect();
		this.manager.onRemoteClipboardData.subscribe(_ => {
				const snackbar = this.snackBar.open('Received from remote clipboard', 'OPEN CLIPBOARD', {
						duration: 1500,
				});
				snackbar.onAction().subscribe(() => this.handleClipboard());
		});
		this.manager.onReconnect.subscribe(_ => this.handleConnect());
	}

	onStateChange($event: string) {
		this.state = $event;

		if ($event === 'CONNECTING') {
		} else if ($event === 'IDLE') {
			this.handleResize();
		} else if ($event === 'CONNECTED') {
			this.handleResize();
		} else if ($event === 'DISCONNECTED') {
			this.handleDisconnect();
		} else if ($event === 'ERROR') {
			this.handleDisconnect();
		} else {
		}
	}

	onWindowResized(_: any) {
		this.handleResize();
	}
}
